module.exports = __webpack_public_path__ + "static/img/logoh.cba97b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/web/logoh.png
// module id = 5f4v
// module chunks = 1